import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "media-highlight-slider__banner-overlay-container" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "media-highlight-slider__navigation"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

import {
  ref, computed, onMounted, nextTick, onBeforeUnmount,
} from 'vue';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'MediaHighlightSlider',
  props: {
  banners: {
    type: Array,
    default: () => [] as Array<any>,
  },
  widthToHeightRatio: {
    type: Number,
    default: 100,
  },
},
  setup(__props) {

const props = __props



const forceComputeScroll = ref(0);
const container = ref({} as any);

const canScrollRight = computed(() => {
  if (forceComputeScroll.value < 0 || props.banners.length === 0) {
    return false;
  }

  const currentScrollLeftWithMargin = container.value.scrollLeft + 10;
  const totalScrollTrackOutsideView = container.value.scrollWidth - container.value.clientWidth;

  return container.value
    && currentScrollLeftWithMargin < totalScrollTrackOutsideView;
});

const canScrollLeft = computed(() => {
  if (forceComputeScroll.value < 0 || props.banners.length === 0) {
    return false;
  }

  return container.value && container.value.scrollLeft > 0;
});

let refreshInterval: undefined|number;
onMounted(async () => {
  await nextTick();
  refreshInterval = setInterval(refreshScrollableState, 500);
});

onBeforeUnmount(() => {
  clearInterval(refreshInterval);
});

function refreshScrollableState() {
  forceComputeScroll.value = forceComputeScroll.value === 0 ? 1 : 0;
}

function getScrollIncrement() {
  return (container.value.scrollWidth / props.banners.length)
    + parseFloat(getComputedStyle(document.documentElement).fontSize);
}

function goPrev() {
  if (!canScrollLeft.value) {
    return;
  }

  container.value.scrollLeft -= getScrollIncrement();
}

function goNext() {
  if (!canScrollRight.value) {
    return;
  }

  container.value.scrollLeft += getScrollIncrement();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "media-highlight-slider__list",
      ref_key: "container",
      ref: container,
      onScroll: refreshScrollableState
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.banners as any[]), (banner) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(banner.element), {
          class: "media-highlight-slider__banner",
          style: _normalizeStyle({ paddingTop: `${props.widthToHeightRatio}%` }),
          key: banner.key,
          to: banner.link
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "media-highlight-slider__banner-image",
              src: banner.imageUrl,
              alt: banner.alt
            }, null, 8, _hoisted_1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banner.overlayClasses, (position) => {
              return (_openBlock(), _createElementBlock("div", {
                key: position,
                class: _normalizeClass([`media-highlight-slider__banner-overlay--${position.name}`, 'media-highlight-slider__banner-overlay'])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      innerHTML: banner.body,
                      class: _normalizeClass(item)
                    }, null, 10, _hoisted_3))
                  }), 128))
                ])
              ], 2))
            }), 128))
          ]),
          _: 2
        }, 1032, ["style", "to"]))
      }), 128))
    ], 544),
    (_unref(canScrollLeft) && _unref(canScrollRight))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(canScrollLeft))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                onClick: _withModifiers(goPrev, ["prevent"]),
                class: "media-highlight-slider__navigation-prev"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_unref(canScrollRight))
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "#",
                onClick: _withModifiers(goNext, ["prevent"]),
                class: "media-highlight-slider__navigation-next"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})